<template lang="pug">
  .scroll-fix-table.open-table
    vue-custom-scrollbar(
    class="table-wrapper"
    :settings="settings"
    )
      table.table
        thead.table__head
          tr.table__row
            th.table__cell(v-for="head in tabHead")
              .table__cell-content {{ head.title }}
            th.table__cell.fixed
        tbody.table__body(v-for="item in tabData")
          tr.table__row
            td.table__cell
              .table__cell-content
                .table__cell-content {{item.name}}
            td.table__cell.fixed
              .table__cell-content.table__cell-content_align-right
                router-link.button.button_square.table__cell-control(
                :to="`/pages/manager/camps/${item.id}/`"
                )
                  img(src="@/assets/images/icons/icon-edit.svg")
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  name: "ManagerCampsRegistryScrollFixTable",
  props: [
    "tab-data",
    "tab-head"
  ],
  components: {
    vueCustomScrollbar
  },
  data() {
    return {
      settings: {
        useBothWheelAxes: true
      }
    };
  }
};
</script>
